class LoaderController {
	/*@ngInject*/
	constructor(public language: any) {
	}
}

export const LoaderComponent = {
	templateUrl: "/static/dist/app/login/loader.component.html",
	controllerAs: "$ctrl",
	controller: LoaderController
}